import { notifyError } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const EventAuction =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "SHOW_AUCTION_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/all-events?auctionType=${auctionFilter}&skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "SHOW_AUCTION_SUCCESS" });
      dispatch({ type: "EVENT_AUCTION", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "SHOW_AUCTION_FAILED" });
    }
  };

export const seller_All_Auction =
  (currentPage, totalNumberRow, auctionFilter) => async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "SHOW_LOADING_ALL" });
    try {
      const { data } = await auction.get(
        `/auction/read/my-auction?${
          auctionFilter && "auctionType=" + auctionFilter
        }&skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "SELLER_ALL_AUCTION", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "HIDE_LOADING_ALL" });
    }
  };

export const filter_Auction =
  (filterName, currentPage, totalNumberRow, auctionFilter) =>
  async (dispatch) => {
    const skip = (currentPage - 1) * totalNumberRow;
    dispatch({ type: "SHOW_AUCTION_LOADING" });
    try {
      const { data } = await auction.get(
        `/auction/read/my-auction?filter=${filterName}&${
          auctionFilter && "auctionType=" + auctionFilter
        }&skip=${skip}&limit=${totalNumberRow}`
      );
      dispatch({ type: "SHOW_AUCTION_SUCCESS" });
      dispatch({ type: "FILTER_AUCTION", payload: data });
    } catch (error) {
       notifyError(error.response ? error.response?.data : error.message,error.response?.status);
      dispatch({ type: "SHOW_AUCTION_FAILED" });
    }
  };

export const live_filter_Auction = () => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING_LIVE" });
  try {
    await auction.get(`/auction/read/my-auction?filter=live`).then((res) => {
      dispatch({ type: "HIDE_LOADING_LIVE" });
      dispatch({ type: "LIVE_FILTER_AUCTION", payload: res.data });
    });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_LOADING_LIVE" });
  }
};

export const today_filter_Auction = (auctionFilter) => async (dispatch) => {
  dispatch({ type: "SHOW_AUCTION_LOADING" });
  try {
    const { data } = await auction.get(`/auction/read/my-auction?filter=today`);
    dispatch({ type: "SHOW_AUCTION_SUCCESS" });
    dispatch({ type: "TODAY_FILTER_AUCTION", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "SHOW_AUCTION_FAILED" });
  }
};

export const upcoming_filter_Auction = () => async (dispatch) => {
  dispatch({ type: "SHOW_AUCTION_LOADING" });
  try {
    const { data } = await auction.get(
      `/auction/read/my-auction?filter=upcoming`
    );
    dispatch({ type: "SHOW_AUCTION_SUCCESS" });
    dispatch({ type: "UPCOMING_FILTER_AUCTION", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "SHOW_AUCTION_FAILED" });
  }
};

export const readLiveOffers = () => async (dispatch) => {
  dispatch({ type: "GETTING_LIVE_OFFERS" });
  try {
    const { data } = await auction.get(`/auction/read/live-offers`);
    dispatch({ type: "LIVE_OFFERS", payload: data });
  } catch (error) {
     notifyError(error.response ? error.response?.data : error.message,error.response?.status);
    dispatch({ type: "HIDE_LOADING" });
  }
};

export const getAllLiveAuctionForSeller = () => async (dispatch) => {
  dispatch({ type: "GETTING_ALL_LIVE_AUCTION_FOR_SELLER" });
  try {
    const { data } = await auction.get("/auction/read/industry-live-offers");
    dispatch({ type: "GOT_ALL_LIVE_AUCTION_FOR_SELLER", payload: data });
  } catch (err) {
    dispatch({ type: "CANNOT_GET_ALL_LIVE_AUCTION_FOR_SELLER" });
  }
};

export const getAllTodayUpComingAuction = () => async (dispatch) => {
  dispatch({ type: "GETTING_TODAY_OFFERS" });
  try {
    const { data } = await auction.get(
      "/auction/read/upcoming/industry-auctions"
    );
    dispatch({ type: "GOT_TODAY_OFFERS", payload: data });
  } catch (err) {
    dispatch({ type: "CANNOT_GET_TODAY_OFFERS" });
  }
};
